/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import { DefaultLinkWidget as OldLinkWidget, PointModel, LinkWidget } from '@projectstorm/react-diagrams';
import BoldLinkPath from '../LinkHelpers';

const CustomLinkPlugWidget = (props: any) => {
  // const color = (props.selected) ? props.colorSelected : props.color;
  const color = props.colorSelected;
  return (
    <g>
      <rect key={1} x={props.point.getPosition().x - 10} y={props.point.getPosition().y - 9} fill={color} height="12" id="svg_21" stroke={color} strokeWidth="0" width="20" />
      <rect key={2} x={props.point.getPosition().x - 10 + 3} y={props.point.getPosition().y - 9 + 3} fill={color} height="12" id="svg_22" stroke={color} strokeWidth="0" transform="matrix(1 0 0 1 0 0)" width="14" />
      <rect key={3} x={props.point.getPosition().x - 10 + 6} y={props.point.getPosition().y - 9 + 7} fill={color} height="11" id="svg_23" stroke={color} strokeWidth="0" transform="matrix(1 0 0 1 0 0)" width="8" />
      <rect key={4} x={props.previousPoint.getPosition().x - 10} y={props.previousPoint.getPosition().y - 9} fill={color} height="12" id="svg_21" stroke={color} strokeWidth="0" width="20" />
      <rect key={5} x={props.previousPoint.getPosition().x - 10 + 3} y={props.previousPoint.getPosition().y - 9 + 3} fill={color} height="12" id="svg_22" stroke={color} strokeWidth="0" transform="matrix(1 0 0 1 0 0)" width="14" />
      <rect key={6} x={props.previousPoint.getPosition().x - 10 + 6} y={props.previousPoint.getPosition().y - 9 + 7} fill={color} height="11" id="svg_23" stroke={color} strokeWidth="0" transform="matrix(1 0 0 1 0 0)" width="8" />
    </g>
  );
};

class DefaultLinkWidget extends OldLinkWidget {
  generatePlug(point: PointModel, previousPoint: PointModel): JSX.Element {
    return (
      <CustomLinkPlugWidget
        key={point.getID()}
        point={point as any}
        previousPoint={previousPoint as any}
        selected={this.props.link.isSelected()}
        colorSelected={this.props.link.getOptions().selectedColor}
        color={(this.props.link.getTargetPort() == null) ? this.props.link.getOptions().selectedColor : this.props.link.getOptions().color}
      />
    );
  }

  render() {
    // ensure id is present for all points on the path
    if (this.props.link.getOptions().selectedColor) {
      // @ts-ignore
      this.props.link.setColor(this.props.link.getOptions().selectedColor);
    }
    const points = this.props.link.getPoints();
    const paths = [];
    this.refPaths = [];
    const str = this.props.link.getSVGPath();
    const myElement = this.generateLink(
      str,
      {
        onMouseEnter: () => {
          BoldLinkPath(this.props.link, 8);
          this.props.link.setHovered(true);
          this.props.diagramEngine.repaintCanvas();
        },
        onMouseLeave: () => {
          BoldLinkPath(this.props.link, 2);
          this.props.link.setHovered(false);
          this.props.diagramEngine.repaintCanvas();
        },
      },
      '0',
    );
    paths.push(myElement);

    paths.push(this.generatePlug(points[0], points[points.length - 1]));

    return <g className="link-default" data-default-link-test={this.props.link.getOptions().testName}>{paths}</g>;
  }
}

export default DefaultLinkWidget;

// const offsetPath = (str: string): string => {
//   const split: string[] = str.split(/[, LM]+/);
//   const offset = 16;
//   const points = [Number(split[1]), Number(split[2]), Number(split[7]), Number(split[8])];
//   const diffX = points[0] - points[2];
//   const diffY = points[1] - points[3];
//   if (diffX === 0 && diffY === 0) {
//     return str;
//   }
//   if (Math.abs(diffX) > Math.abs(diffY)) {
//     const adjust = offset * (diffY / diffX);
//     if (diffX < 0) {
//       points[0] += offset + 1;

//       points[2] -= offset - 1;
//       points[1] += adjust;
//       points[3] -= adjust;
//     } else {
//       points[2] += offset + 1;
//       points[0] -= offset - 1;
//       points[1] -= adjust;
//       points[3] += adjust;
//     }
//   } else {
//     const adjust = offset * (diffX / diffY);
//     if (diffY < 0) {
//       points[1] += offset + 1;
//       points[3] -= offset - 1;
//       points[0] += adjust + 1;
//       points[2] -= adjust - 1;
//     } else {
//       points[3] += offset + 1;
//       points[1] -= offset - 1;
//       points[0] -= adjust - 1;
//       points[2] += adjust + 1;
//     }
//   }
//   return `M${points[0]} ${points[1]} ${split[3]} ${split[4]}, ${split[5]} ${split[6]}, ${points[2]} ${points[3]} `;
// };
